export default __webpack_public_path__ + "static/media/Drizzle-Clouds-Sun.0d0f7120.png";